import React from 'react';
import {Popup} from '../common';

const TextInput = (props) => {
  return (
    <div
      className={`field-wrapper ${props.labelPositionTop && 'label-on-top'}`}>
      <label className={`field-label ${props.labelClassName}`}>
        {props.label}

        {props.information && (
          <Popup
            trigger={() => (
              <img
                style={{marginLeft: '10px'}}
                alt=""
                src={require('./../../images/icon-tooltip.png')}
                width="18px"
                height="18px"
              />
            )}
            position="top center"
            on={['hover']}
            closeOnDocumentClick>
            <span>{props.information}</span>
          </Popup>
        )}
      </label>

      <div className="field">
        <input
          type={props.type}
          value={props.value}
          onChange={props.onChangeHandler}
        />
        {props.error && (
          <div style={{color: 'red'}}>
            {props.error.map((message) => message)}
          </div>
        )}
      </div>
    </div>
  );
};

export {TextInput};
